<template>
  <vx-card id="announcementViewDataContainer" class="vs-con-loading__container" :title="announcement.title" :subtitle="announcement.user.name">
    <template slot="actions">
      <span>{{ announcement.date | readableDate }}</span>
    </template>

    <div class="announcement-content" v-html="announcementContent"></div>
  </vx-card>
</template>

<script>
import Announcements from '@/models/Announcements'
import {EventBus} from '@/../eventbus'

export default {
  name: 'Shared.Announcement.View',
  props: {
    isVisible: {
      type: Boolean,
      required: false
    }
  },
  watch: {
    isVisible (val) {
      if (!val) {
        this.resetFormData()
      }
    }
  },
  computed: {
    announcementContent: {
      get () {
        try {
          return JSON.parse(this.announcement.content)
        } catch (e) {
          return this.announcement.content
        }
      },
      set (val) {
        this.announcement.content = val
      }
    }
  },
  data () {
    return {
      announcement: {
        title: '',
        content: '',
        user: {
          name: ''
        },
        is_published: ''
      }
    }
  },
  mounted () {
    EventBus.$on('initAnnouncementViewData', this.view)
  },
  methods: {
    async view (id) {
      this.$vs.loading({container: '#announcementViewDataContainer'})
      try {
        const response = await Announcements.view({ id })
        this.announcement = response.data.data
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
      this.$vs.loading.close('#announcementViewDataContainer > .con-vs-loading')
    },
    resetFormData () {
      this.announcement = {
        title: '',
        content: '',
        user: {
          name: ''
        },
        is_published: ''
      }
    }
  }
}
</script>

<style scoped>

</style>
